// extracted by mini-css-extract-plugin
export default {"radio":"radio_radio__B3Pa0","input":"radio_input__Wh94-","label":"radio_label__oh2KG"};